import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import type { ApiResponse } from '@/app/types'
import api from '@/app/services/apiNir.ts'
import type { AxiosResponse } from 'axios'
import type { ContactEntry } from '@/domains/home/services/nir/configurations/types/contacts.ts'

export const useContactConfigStore = defineStore('contact-config', () => {
    const okResponse: Ref<object | undefined> = ref()
    const contacts: Ref<ContactEntry[] | undefined> = ref()

    const fetchContacts = async () => {
        return api.get('/v1/configurations/contacts')
            .then((response: AxiosResponse<ApiResponse<ContactEntry[]>>) => {
                contacts.value = response.data.data
            })
    }

    const createContact = async (payload: object) => {
        return api.post('/v1/configurations/contacts', payload)
            .then((response: AxiosResponse<ApiResponse<object>>) => {
                okResponse.value = response.data.data
            })
    }

    const updateContact = async (payload: object) => {
        return api.put('/v1/configurations/contacts', payload)
            .then((response: AxiosResponse<ApiResponse<object>>) => {
                okResponse.value = response.data.data
            })
    }

    return {
        okResponse,
        contacts,
        fetchContacts,
        createContact,
        updateContact,
    }
})
